import {ref, computed, watch, toRaw} from "vue";
import {useStore} from "vuex";
import {useVuelidate} from "@vuelidate/core";
import {required, helpers} from "@vuelidate/validators";
import {useRoles} from "@/hooks/role";
import {useRoute} from "vue-router";

export function useNotices() {
    const store = useStore();
    const {roles, rolesApp} = useRoles();
    const allRoles = computed(() => roles.value.length ? [...rolesApp.value.map(item => item.id), ...roles.value.map(item => item.id)] : []);
    const ownerId = computed(() => roles.value.length ? roles.value.find(item => item.name === 'owner') : null)
    const route = useRoute();
    const notices = computed(() => store.getters.getListNotices);
    const notice = computed(() => store.getters.getCurrentNotice);
    const typeNotices = computed(() => store.getters.getListTypeNotices);

    const lang = computed(() => store.getters.getLang);
    const textField = computed(() => route.params.id ? `text${lang.value === 'ru' ? '' : `_${lang.value}`}`: 'text');

    const isCreate = ref(false);
    const isUpdate = ref(false);

    const loadNotice = async (id) => {
        await store.dispatch('fetchNotice', id);
    };

    const loadNotices = async (params = {}) => {
        await store.dispatch('fetchNotices', params);
    };

    const loadTypeNotices = async () => {
        await store.dispatch('fetchTypeNotices');
    };

    const formCreateNotice = ref({
        push_type_id: '',
        user_id: null,
        send_date: '',
        send_time: '',
        expiration_date: '',
        send_now: false,
        // senders_all_roles: 0,
        text: '',
        text_en: '',
        title: '',
        title_en: '',
        role: '',
        control_status: 'all',
    })

    const message = 'Поле обязательно для заполнения';

    const rules = computed(() => ({
        push_type_id: {required: helpers.withMessage(message, required)},
        send_now: {required: helpers.withMessage(message, required)},
        text: {required: helpers.withMessage(message, required)},
        text_en: {required: helpers.withMessage(message, required)},
        title: {required: helpers.withMessage(message, required)},
        title_en: {required: helpers.withMessage(message, required)},
        role: {required: helpers.withMessage(message, required)},
        control_status: {...(formCreateNotice.value.role === ownerId.value?.id ? {required: helpers.withMessage(message, required)} : {})},
        user_id: {...(formCreateNotice.value.role === -1 ? {required: helpers.withMessage(message, required)} : {})}
    }));

    const v$ = useVuelidate(rules, formCreateNotice);

    const checkLangFields = () => {
        if (formCreateNotice.value.text && !formCreateNotice.value.text_en) {
            formCreateNotice.value.text_en = formCreateNotice.value.text
        }
        if (formCreateNotice.value.title && !formCreateNotice.value.title_en) {
            formCreateNotice.value.title_en = formCreateNotice.value.title
        }
        if (formCreateNotice.value.text_en && !formCreateNotice.value.text) {
            formCreateNotice.value.text = formCreateNotice.value.text_en
        }
        if (formCreateNotice.value.title_en && !formCreateNotice.value.title) {
            formCreateNotice.value.title = formCreateNotice.value.title_en
        }
    }

    const createNotice = async () => {
        checkLangFields()
        const result = await v$.value.$validate();
        if (!result) {
            return false;
        }

        const date = toRaw(formCreateNotice.value.send_date) instanceof Date
            ? new Date(formCreateNotice.value.send_date)
            : false;

        const send_date = date ?
            `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}.${(date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}.${date.getFullYear()}`
            : '';

        const date2 = toRaw(formCreateNotice.value.expiration_date) instanceof Date
            ? new Date(formCreateNotice.value.expiration_date)
            : false;

        const expiration_date = date2 ?
            `${date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate()}.${(date2.getMonth() + 1) < 10 ? '0' + (date2.getMonth() + 1) : date2.getMonth() + 1}.${date2.getFullYear()}`
            : '';

        const formatterForm = {
            push_type_id: formCreateNotice.value.push_type_id,
            text: formCreateNotice.value.text,
            text_en: formCreateNotice.value.text_en,
            title: formCreateNotice.value.title,
            title_en: formCreateNotice.value.title_en,
            ...(send_date ? {send_date: send_date} : {}),
            ...(formCreateNotice.value.send_time ? {send_time: formCreateNotice.value.send_time} : {}),
            send_now: Number(formCreateNotice.value.send_now),
            ...(formCreateNotice.value.role && !formCreateNotice.value.user_id ? {role: formCreateNotice.value.role === -2 ? allRoles.value : [formCreateNotice.value.role]} : {role: []}),
            ...(formCreateNotice.value.role === ownerId.value?.id ? {control_status: formCreateNotice.value.control_status} : {}),
            ...(expiration_date ? {expiration_date: expiration_date} : {}),
            ...(formCreateNotice.value.user_id ? {user_id: formCreateNotice.value.user_id.value} : {}),
        }

        await store.dispatch(
            'fetchCreateNotice',
            formatterForm
        );

        isCreate.value = true;
    };

    const createNoticeAsDraft = async () => {
        checkLangFields()
        const result = await v$.value.$validate();
        if (!result) {
            return false;
        }
        const date2 = toRaw(formCreateNotice.value.expiration_date) instanceof Date
            ? new Date(formCreateNotice.value.expiration_date)
            : false;

        const expiration_date = date2 ?
            `${date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate()}.${(date2.getMonth() + 1) < 10 ? '0' + (date2.getMonth() + 1) : date2.getMonth() + 1}.${date2.getFullYear()}`
            : '';

        const formatterForm = {
            push_type_id: formCreateNotice.value.push_type_id,
            text: formCreateNotice.value.text,
            text_en: formCreateNotice.value.text_en,
            title: formCreateNotice.value.title,
            title_en: formCreateNotice.value.title_en,
            send_now: 0,
            ...(formCreateNotice.value.role && !formCreateNotice.value.user_id ? {role: formCreateNotice.value.role === -2 ? allRoles.value : [formCreateNotice.value.role]} : {role: []}),
            ...(formCreateNotice.value.role === ownerId.value?.id ? {control_status: formCreateNotice.value.control_status} : {}),
            ...(expiration_date ? {expiration_date: expiration_date} : {}),
            ...(formCreateNotice.value.user_id ? {user_id: formCreateNotice.value.user_id.value} : {}),
        }
        await store.dispatch('fetchCreateNotice', formatterForm);
        return true
    };

    const updateNotice = async (id) => {
        checkLangFields()
        const result = await v$.value.$validate();
        if (!result) {
            return;
        }
        const date = toRaw(formCreateNotice.value.send_date) instanceof Date
            ? new Date(formCreateNotice.value.send_date)
            : false;

        const send_date = date ?
            `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}.${(date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}.${date.getFullYear()}`
            : false;

        if (send_date) {
            formCreateNotice.value.send_date = send_date;
        }

        const date2 = toRaw(formCreateNotice.value.expiration_date) instanceof Date
            ? new Date(formCreateNotice.value.expiration_date)
            : false;

        const expiration_date = date2 ?
            `${date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate()}.${(date2.getMonth() + 1) < 10 ? '0' + (date2.getMonth() + 1) : date2.getMonth() + 1}.${date2.getFullYear()}`
            : '';

        const formatterForm = {
            push_type_id: formCreateNotice.value.push_type_id,
            text: formCreateNotice.value.text,
            text_en: formCreateNotice.value.text_en,
            title: formCreateNotice.value.title,
            title_en: formCreateNotice.value.title_en,
            send_now: Number(formCreateNotice.value.send_now),
            ...(send_date ? {send_date: send_date} : {}),
            ...(formCreateNotice.value.send_time ? {send_time: formCreateNotice.value.send_time} : {}),
            ...(formCreateNotice.value.role && !formCreateNotice.value.user_id ? {role: formCreateNotice.value.role === -2 ? allRoles.value : [formCreateNotice.value.role]} : {role: []}),
            ...(formCreateNotice.value.role === ownerId.value?.id ? {control_status: formCreateNotice.value.control_status} : {}),
            ...(expiration_date ? {expiration_date: expiration_date} : {}),
            ...(formCreateNotice.value.user_id ? {user_id: formCreateNotice.value.user_id.value} : {user_id: null})
        }

        await store.dispatch('fetchUpdateNotice', {
            id,
            body: formatterForm
        });
        isUpdate.value = true;
    };

    const deleteNotice = async (id) => {
        await store.dispatch('fetchDeleteNotice', id);
    };

    return {
        notice,
        notices,
        typeNotices,
        updateNotice,
        loadNotices,
        loadNotice,
        loadTypeNotices,
        deleteNotice,
        createNotice,
        createNoticeAsDraft,
        formCreateNotice,
        isCreate,
        isUpdate,
        v$,
    }
}